import Modal from "react-bootstrap/Modal";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Styles from "./ViewCustomerWishlist.module.css";
import { viewCustomerWishlistService } from "../../../Services/ApiServices";
import cancelIcon from "../../../Assets/cross.png";
import Profile from "../../../Assets/user_img.png";
import mail from "../../../Assets/email.png";
import phone from "../../../Assets/mbl.png";
import location from "../../../Assets/location_img.png";
import Loader from "../../../SharedComponents/Loader/Loader";

export default function ViewCustomerWishlist(props) {
  const navigate = useNavigate();
  const [viewData, setViewData] = useState(null);
  const [isLoader, setIsLoader] = useState(false);
  const [readmoreId, setReadmoreId] = useState([]);

  useEffect(() => {
    handleView();
  }, []);

  const handleView = () => {
    setIsLoader(true);
    viewCustomerWishlistService(props.id)
      .then((res) => setViewData(res.data))
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg);
        } else {
          toast.error("Something went wrong!!");
        }
      })
      .finally(() => setIsLoader(false));
  };

  const handleData = () => {
    let updateData =
      viewData?.wishlist_products?.map((ele) => {
        if (ele?.unit_id) {
          return {
            ...ele,
            price: ele?.selling_price,
            colorItem: ele?.product_image[0],
            selectedUnit: {
              id: ele?.unit_id,
              unit_id: ele?.unit_name,
              selling_price: ele?.selling_price,
              price: ele?.selling_price,
              quantity: parseInt(ele?.product_quantity),
              min_quantity: ele?.min_quantity,
            },
          };
        }
        return {
          ...ele,
          price: ele?.selling_price,
          colorItem: ele?.product_image[0],
        };
      }) || [];

    let additionalList = [];
    if (Array.isArray(viewData?.additional_products)) {
      additionalList = viewData.additional_products;
    } else if (typeof viewData?.additional_products === "string") {
      try {
        const parsed = JSON.parse(viewData.additional_products);
        if (Array.isArray(parsed)) {
          additionalList = parsed;
        }
      } catch (e) {
        additionalList = [];
      }
    }

    let manualProducts = additionalList.map((e, index) => {
      const qty = Number(e?.product_quantity ?? e?.quantity ?? e?.qty ?? 1);
      const unit = e?.product_unit || e?.unit || e?.unit_name || "";
      const prodName = e?.product_name || e?.name || "";
      const brandName = e?.brand_name || e?.brand || "";
      const manualId = `manual_${Date.now()}_${index}`;
      return {
        product_id: manualId,
        product_name: prodName,
        brand_name: brandName,
        unit: unit,
        product_unit: unit,
        unit_name: unit,
        quantity: qty,
        product_quantity: qty,
        qty: qty,
        selling_price: 0,
        price: 0,
        total_price: 0,
        total_amount: 0,
        active_status: 1,
        min_quantity: 1,
        max_quantity: 9999,
        kansas_quantity: 9999,
        product_image: [],
        product_images: [],
        product_units: [],
        product_category_id: "manual",
        product_subcategory_id: "manual",
        selectedUnit: unit
          ? {
            id: manualId,
            unit_id: unit,
            qty: qty,
            selling_price: 0,
            price: 0,
            total_amount: 0,
            min_quantity: 1,
            quantity: 9999,
          }
          : undefined,
        is_manual: true,
        customer_wishlist_id: manualId,
      };
    });

    navigate("/store/categories", {
      state: {
        ...viewData,
        wishlist_products: [...updateData, ...manualProducts],
        fromCustomerWishlist: true,
      },
    });
  };

  const handleTotalAmount = (data) => {
    return data.reduce((prev, current) => prev + current?.total_price, 0);
  };

  return (
    <div>
      <Loader isLoader={isLoader} />

      <Modal show={props.state} onHide={props.onHide} size="lg" centered>
        <Modal.Body>
          {/* Header */}
          <div className={Styles.cancelImgParentContainer}>
            <p className="fontBold">
              View Customer <span className="orange">Product</span>
            </p>

            <img
              onClick={props.onHide}
              src={cancelIcon}
              alt="cancel"
              className={Styles.cancelImg}
            />
          </div>

          {/* Customer Info */}
          <div>
            <div className={Styles.usernameParentContainer}>
              <div className={Styles.usernameContainer}>
                <img className={Styles.img} src={Profile} alt="profile" />
                <p className={Styles.username}>{viewData?.customer_name}</p>
              </div>
            </div>

            <div className={Styles.detailContainer}>
              <img className={Styles.img} src={phone} alt="phone" />
              <p className={Styles.detail}>{viewData?.mobile_no}</p>
            </div>

            <div className={Styles.detailContainer}>
              <img className={Styles.img} src={mail} alt="mail" />
              <p className={Styles.detail}>{viewData?.email || "-"}</p>
            </div>

            {/* Address + Delivery Type */}
            <div className={Styles.addressRow}>
              {/* Address */}
              <div className={Styles.detailContainer}>
                <img
                  className={Styles.location}
                  src={location}
                  alt="location"
                />
                <p className={Styles.detail}>
                  {viewData?.address},
                  <br />
                  {viewData?.state_name},
                  <br />
                  {viewData?.city_name}.
                </p>
              </div>

              {/* Delivery Type */}
              <div className={Styles.deliveryType}>
                <span className={Styles.deliveryLabel}>Delivery Type</span>
                <p className={Styles.deliveryValue}>
                  {viewData?.delivery_type_name || "-"}
                </p>
              </div>
            </div>
          </div>

          {/* Wishlist Table */}
          {viewData?.wishlist_products?.length > 0 && (
            <div className={Styles.parentContainer}>
              <div className={Styles.childContainer + " mt-3"}>
                <table>
                  <thead>
                    <tr>
                      <th className={Styles.th + " label text-center"}>S.No</th>
                      <th className={Styles.productname + " label text-center"}>
                        Product Name
                      </th>
                      <th className={Styles.th + " label text-center"}>Qty</th>
                      <th className={Styles.th + " label text-center"}>Unit</th>
                      <th className="label text-center">Price</th>
                      <th className="label text-center">Total</th>
                    </tr>
                  </thead>

                  <tbody className={Styles.data}>
                    {viewData.wishlist_products.map((e, index) => (
                      <tr key={e.product_id}>
                        <td className="text-center">{index + 1}</td>

                        <td
                          className={
                            Styles.productname + " contentFont text-center"
                          }
                        >
                          {readmoreId.includes(e.product_id)
                            ? e.product_name
                            : e.product_name.substring(0, 37)}
                          {e.product_name.length > 37 &&
                            !readmoreId.includes(e.product_id)
                            ? "..."
                            : null}

                          {e.product_name.length > 37 && (
                            <span
                              className={Styles.readmore + " orange"}
                              onClick={() =>
                                setReadmoreId((prev) =>
                                  prev.includes(e.product_id)
                                    ? prev.filter((id) => id !== e.product_id)
                                    : [...prev, e.product_id],
                                )
                              }
                            >
                              {readmoreId.includes(e.product_id)
                                ? "Show Less"
                                : "Read More"}
                            </span>
                          )}
                        </td>

                        <td className={Styles.td}>{e.quantity}</td>
                        <td className={Styles.td}>{e.unit_name || "-"}</td>
                        <td className={Styles.td}>
                          ₹ {e.selling_price.toFixed(2)}
                        </td>
                        <td className={Styles.td}>
                          ₹ {e.total_price.toFixed(2)}
                        </td>
                      </tr>
                    ))}

                    <tr>
                      <td colSpan={4} />
                      <td className="label text-center">Total</td>
                      <td className="label text-center">
                        ₹{" "}
                        {handleTotalAmount(viewData.wishlist_products).toFixed(
                          2,
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Manually Added Products Table */}
          {(() => {
            let additionalProductsList = [];
            if (Array.isArray(viewData?.additional_products)) {
              additionalProductsList = viewData.additional_products;
            } else if (typeof viewData?.additional_products === "string") {
              try {
                const parsed = JSON.parse(viewData.additional_products);
                if (Array.isArray(parsed)) {
                  additionalProductsList = parsed;
                }
              } catch (e) {
                additionalProductsList = [];
              }
            }

            if (!additionalProductsList || additionalProductsList.length === 0) {
              return null;
            }

            return (
              <div className={Styles.parentContainer}>
                <p className="fontBold mt-3 mb-1">
                  Additional <span className="orange">Products</span>
                </p>
                <div className={Styles.childContainer}>
                  <table>
                    <thead>
                      <tr>
                        <th className={Styles.th + " label text-center"}>
                          S.No
                        </th>
                        <th
                          className={Styles.productname + " label text-center"}
                        >
                          Product Name
                        </th>
                        <th className={Styles.th + " label text-center"}>
                          Brand
                        </th>
                        <th className={Styles.th + " label text-center"}>
                          Unit
                        </th>
                        <th className={Styles.th + " label text-center"}>
                          Qty
                        </th>
                      </tr>
                    </thead>

                    <tbody className={Styles.data}>
                      {additionalProductsList.map((e, index) => {
                        const manualKey = `manual_${index}_${e?.product_name}`;
                        const productName = e?.product_name || e?.name || "-";
                        const brandName = e?.brand_name || e?.brand || "-";
                        const unit =
                          e?.product_unit || e?.unit || e?.unit_name || "-";
                        const qty = Number(
                          e?.product_quantity ?? e?.quantity ?? e?.qty ?? 1,
                        );

                        return (
                          <tr key={manualKey}>
                            <td className="text-center">{index + 1}</td>
                            <td
                              className={
                                Styles.productname + " contentFont text-center"
                              }
                            >
                              {readmoreId.includes(manualKey)
                                ? productName
                                : productName.substring(0, 37)}
                              {productName.length > 37 &&
                                !readmoreId.includes(manualKey)
                                ? "..."
                                : null}

                              {productName.length > 37 && (
                                <span
                                  className={Styles.readmore + " orange"}
                                  onClick={() =>
                                    setReadmoreId((prev) =>
                                      prev.includes(manualKey)
                                        ? prev.filter((id) => id !== manualKey)
                                        : [...prev, manualKey],
                                    )
                                  }
                                >
                                  {readmoreId.includes(manualKey)
                                    ? "Show Less"
                                    : "Read More"}
                                </span>
                              )}
                            </td>
                            <td className={Styles.td}>{brandName}</td>
                            <td className={Styles.td}>{unit}</td>
                            <td className={Styles.td}>{qty}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })()}

          {/* Action Button */}
          <div className={Styles.btnContainer}>
            <button onClick={handleData} className={Styles.btn}>
              Generate Bill
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
